import { styled } from '$utils/theme'
import { rem } from 'polished'

export const StyledGooleImage = styled.img`
  max-height: ${p => rem(p.theme.sizes.mini)};
`

export const StyledGooleBlock = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: ${p => rem(p.theme.sizes.base)};
  border: solid 1px ${p => p.theme.colors.lightGrey};
  border-top: none;
`



// WEBPACK FOOTER //
// ./src/views/components/PoweredByGoogle/PoweredByGoogle.style.ts